import { Routes } from '@angular/router';
import { adminGuard, customerGuard, roleRedirectGuard } from './core/guards';

export const routes: Routes = [
	// Default route: redirect based on authentication status and role
	{ path: '', redirectTo: 'auth', pathMatch: 'full' },
	{
		path: 'auth',
		canActivate: [roleRedirectGuard], // Redirect authenticated users to their dashboard
		loadChildren: () =>
			import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
	},
	{
		path: 'customer',
		canActivate: [customerGuard], // Protect customer routes
		loadChildren: () =>
			import('./features/customer/customer.routes').then((m) => m.CUSTOMER_ROUTES),
	},
	{
		path: 'admin',
		canActivate: [adminGuard], // Protect admin routes
		loadChildren: () =>
			import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
	},

	// Fallback: any unknown route goes to auth
	{ path: '**', redirectTo: 'auth' },
];
